

















import Vue from 'vue';
import { mapGetters } from 'vuex';
import CopyrightPanel from '@/components/Common/CopyrightPanel.vue';

export default Vue.extend({
    name: 'ErrorLayout',
    components: {
        CopyrightPanel,
    },
    computed: {
        ...mapGetters('app', {
            appName: 'getAppName'
        }),
    }
});
